import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export default function ReportsSkeleton() {
  return (
    <div className="font-dashboard" role="status" aria-label="Loading reports">
      <div className="flex flex-col justify-between gap-4 sm:flex-row">
        <div className="flex flex-col gap-2"><Skeleton className="h-9 w-36" /><Skeleton className="h-4 w-80 max-w-full" /></div>
        <div className="flex gap-3"><Skeleton className="h-10 w-32" /><Skeleton className="h-10 w-28" /><Skeleton className="h-10 w-28" /></div>
      </div>
      <div className="mt-8 grid grid-cols-2 gap-4 xl:grid-cols-4">
        {[0, 1, 2, 3].map((item) => <Card key={item} className="rounded-2xl border-dash-border p-6 shadow-none"><Skeleton className="h-3 w-28" /><Skeleton className="mt-5 h-10 w-24" /></Card>)}
      </div>
      <div className="mt-4 grid gap-4 lg:grid-cols-2">
        {[0, 1].map((card) => (
          <Card key={card} className="rounded-2xl border-dash-border shadow-none">
            <CardHeader><Skeleton className="h-5 w-36" /></CardHeader>
            <CardContent className="flex flex-col gap-4">
              {[0, 1, 2, 3, 4].map((row) => <div key={row} className="flex items-center gap-4"><Skeleton className="h-4 w-24" /><Skeleton className="h-3 flex-1 rounded-full" /><Skeleton className="h-4 w-6" /></div>)}
            </CardContent>
          </Card>
        ))}
      </div>
      <span className="sr-only">Loading report cards…</span>
    </div>
  );
}
